import addEventListener from './add-event-listener'
import once from './once'

export default addEventListener

export { once }
